import { Box } from '@gemini/core';
import { Button } from '@gemini/ui';
import { useTranslation } from '@aviv-unified-frontend/runtime/i18n';
import { NAME_SPACE } from '@mfe-presentation/hooks/useLoadTranslations';
import Icon from '@mfe-presentation/components/Icon';
import { useAppContext } from '@mfe-presentation/contexts';
import { Portal } from '@aviv-estimation-funnel/estimation-data-models/enums';
import { isFrenchPortal } from '@mfe-helpers/portalHelpers';

const FsrboPromotion = () => {
    const { t } = useTranslation(NAME_SPACE);
    const { portal } = useAppContext();

    const getFsrboUrl = (portal: Portal) => {
        switch (portal) {
            case Portal.ImmoWelt:
                return 'https://www.immowelt.de/anbieten/immobilienanzeigen?m=estimate_confirmation_new_classified_deposit_landing_sell';
            case Portal.SeLoger:
            case Portal.LogicImmo:
                return 'https://www.seloger.com/depot-annonce/';
            default:
                return '';
        }
    };

    return (
        <Box
            display="flex"
            flexDirection="column"
            borderWidth="borderWidth.1"
            borderStyle="solid"
            borderColor="color.border.light.default"
            borderRadius="radius.8"
            alignItems="center"
            textAlign="center"
            typography="typography.body.12.regular"
            width="100%"
            paddingVertical="spacing.32"
            paddingHorizontal="spacing.32"
            gap="spacing.20"
        >
            <Icon
                data-testid="listing-icon"
                width="80"
                height="80"
                name={isFrenchPortal(portal) ? 'property-listing' : 'empty-no-listing'}
            />
            <Box typography="typography.headline.24.bold">
                {t('step_results.resultCard.fsrboPromotion.title')}
            </Box>
            <Box typography="typography.body.16.regular" color="color.content.default.default">
                {t('step_results.resultCard.fsrboPromotion.subtitle')}
            </Box>
            <Button isExternal href={getFsrboUrl(portal)} variant="secondary">
                {t('step_results.resultCard.fsrboPromotion.cta')}
            </Button>
        </Box>
    );
};

export default FsrboPromotion;
